import { enqueueSnackbar } from '../notificationActions';
import { SnackbarMessageVariants } from '../../../helpers/enums';
import { TopInboundAndOutboundLanesService } from '../../../interfaces/marketInsightsServiceInterfaces';
import ApiService from '../../../services/apiService';
import Endpoints from '../../../services/endpoints';

export const TOP_INBOUND_LANES_REQUEST = 'TOP_INBOUND_LANES_REQUEST';
export const TOP_OUTBOUND_LANES_REQUEST = 'TOP_OUTBOUND_LANES_REQUEST';
export const TOP_INBOUND_LANES_SUCCESS = 'TOP_INBOUND_LANES_SUCCESS';
export const TOP_OUTBOUND_LANES_SUCCESS = 'TOP_OUTBOUND_LANES_SUCCESS';
export const TOP_INBOUND_LANES_FAILURE = 'TOP_INBOUND_LANES_FAILURE';
export const TOP_OUTBOUND_LANES_FAILURE = 'TOP_OUTBOUND_LANES_FAILURE';

const requestTopInboundLanes = (): object => {
    return {
        type: TOP_INBOUND_LANES_REQUEST
    };
};

const requestTopOutboundLanes = (): object => {
    return {
        type: TOP_OUTBOUND_LANES_REQUEST
    };
};

const receiveTopInboundLanes = (json: object): object => {
    return {
        type: TOP_INBOUND_LANES_SUCCESS,
        payload: json
    };
};

const receiveTopOutboundLanes = (json: object): object => {
    return {
        type: TOP_OUTBOUND_LANES_SUCCESS,
        payload: json
    };
};

const requestTopInboundLanesFailed = (): object => {
    return {
        type: TOP_INBOUND_LANES_FAILURE
    };
};

const requestTopOutboundLanesFailed = (): object => {
    return {
        type: TOP_OUTBOUND_LANES_FAILURE
    };
};

export const fetchTopInboundAndOutboundLanes = (query: any, inboundOrOutbound: string, topCount: number = 3): Function => {
    return async (dispatch: any): Promise<void> => {
        if (inboundOrOutbound === 'inbound') {
            dispatch(requestTopInboundLanes());
        } else {
            dispatch(requestTopOutboundLanes());
        }

        const requestBody = {
            ...query,
            topCount
        };

        try {
            const json: TopInboundAndOutboundLanesService = await ApiService.post(Endpoints.rankingArea2areaInboundAndOutbound, requestBody);

            if (Object.keys(json).length > 0) {
                if (inboundOrOutbound === 'inbound') {
                    dispatch(receiveTopInboundLanes(json.top_inbound_lanes));
                } else {
                    dispatch(receiveTopOutboundLanes(json.top_outbound_lanes));
                }
            } else {
                // If no top lanes are returned dispatch an empty object and handle it within the component
                if (inboundOrOutbound === 'inbound') {
                    dispatch(receiveTopInboundLanes([]));
                } else {
                    dispatch(receiveTopOutboundLanes([]));
                }
            }
        } catch (err) {
            if (inboundOrOutbound === 'inbound') {
                dispatch(requestTopInboundLanesFailed());
            } else {
                dispatch(requestTopOutboundLanesFailed());
            }
            if (inboundOrOutbound === 'inbound') {
                dispatch(enqueueSnackbar({
                    message: 'Error occurred while fetching top inbound lanes.',
                    variant: SnackbarMessageVariants.Error
                }));
            } else {
                dispatch(enqueueSnackbar({
                    message: 'Error occurred while fetching top outbound lanes.',
                    variant: SnackbarMessageVariants.Error
                }));
            }
        }
    };
};
